import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { version: `web - ${process.env.REACT_APP_VERSION}`}
});

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const isUnauthorized = error?.response?.status === 401;
    const unauthorizedData = error?.response?.data;
    const isIntegrationError = unauthorizedData?.error_origin === 'integracao';
    const shouldLogout = isUnauthorized && !isIntegrationError;

    if (shouldLogout) {
      localStorage.clear();

      if (unauthorizedData?.message) {
        confirmAlert({
          title: 'Opa!',
          message: unauthorizedData.message,
          buttons: [
            {
              label: 'Ok',
              onClick: () => window.location.reload(),
            },
          ],
        });
        setTimeout(() => window.location.reload(), 5000);
      } else {
        window.location.reload();
      }
    }

    return Promise.reject(error);
  },
);

export default api;
